/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, metric: NonNullable<unknown>, leftValue: NonNullable<unknown>, rightChain: NonNullable<unknown> }} Chain_Page_Compare_Time_No_RightInputs */



/**
* | output |
* | --- |
* | "{leftChain} {metric} is {leftValue}, while {rightChain} has no data" |
*
* @param {Chain_Page_Compare_Time_No_RightInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_time_no_right = /** @type {((inputs: Chain_Page_Compare_Time_No_RightInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Time_No_RightInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} ${i?.metric} is ${i?.leftValue}, while ${i?.rightChain} has no data`)
});